// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-box.form-end[data-v-7f6bd6dc]{flex-wrap:wrap;align-items:center;justify-content:flex-start}.form-end .btn.white[data-v-7f6bd6dc]{margin:12px 0 auto auto}@media (max-width:1919px){.form-end .btn.white[data-v-7f6bd6dc]{margin:12px auto auto 0}}@media (max-width:1023px){.form-end .btn.white[data-v-7f6bd6dc]{margin:12px 0 auto auto}}@media (max-width:550px){.form-end .btn.white[data-v-7f6bd6dc]{margin:12px auto auto}}", ""]);
// Exports
module.exports = exports;
